import { RoutePaths } from "./route-paths";

export const REGEX_EMAIL = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const REGEX_NUMERIC = /^\d+$/;
export const REGEX_ALPHANUMERIC = /^[a-zA-Z0-9]+$/;
export const REGEX_CONTAINS_ALPHANUMERIC = /(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+/;
export const REGEX_CONTAINS_SPECIAL_CHARACTER =
    /[!@#$%^&*(),.?":{}|<>[\]\\\/`~_+=;'’]/;
export const REGEX_BIRTHDATE = /^\d{2}-\d{2}-\d{4}$/;
export const REGEX_PATHNAME = /^[a-z\-_]+$/;
export const REGEX_PHONE = /[0-9\+\-\(\)]/;
export const REGEX_TEXT = /[A-Z a-z]*/;
export const REGEX_NUMBERS = /^[0-9]*$/;
export const REGEX_PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*]).{8,}$/;
export const REGEX_PASSWORD_ALLSPECIAL_CHARACTER = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\W_]).{8,}$/;

export const USER_INT_DOMAIN = ['mapfre', 'middlesea.com'];

export const LOCAL_STORAGE_TOKEN = 'token';
export const LOCAL_STORAGE_ID_TOKEN = 'idToken';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken';
export const LOCAL_STORAGE_ID_TOKEN_CLAIMS = 'idTokenClaims';

export const LOCAL_STORAGE_EXT_TOKEN = 'external_user_token';
export const LOCAL_STORAGE_INT_TOKEN = 'internal_user_token';

export const LOCAL_LANG = 'lang';

export const ROUTES_AUTH = [
    `/login`,
    `/register`,
    `/change-password`,
    `/reset-password`
];